<template>
    <div class="demo-child">
        CHILD:[{{name}}]
    </div>
</template>

<script>
    export default {
        name: "demo-child",
        props: {
            name: {},
        },
        mounted() {
            console.log(`child:${this.name} mounted`)
        },
        destroyed() {
            console.log(`child:${this.name} destroyed`)
        },
    }
</script>

<style lang="scss">

</style>
